import { render, staticRenderFns } from "./BinderPDFStamp.vue?vue&type=template&id=6607f270&"
import script from "./BinderPDFStamp.vue?vue&type=script&lang=js&"
export * from "./BinderPDFStamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports